// extracted by mini-css-extract-plugin
export var cardWrapper = "_63-0";